/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorSavePersonalAddressResponse = {
  type: 'all-of',
  contains: [{
    type: 'ListResponse',
  }, {
    properties: {
      data: {
        type: 'Doctor',
      },
    },
  }],
} as const;
